import React, { useEffect, useState, useCallback } from "react";
import { Skeleton, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";
import api from "../../api/api";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import SaveIcon from "../../../src/assets/orders/Save.svg";
import { addIcon, heartIcon, starIcon } from "./svg";
import { setConfig } from "../../reduxtoolkit/userconfigslice";
import { OrderIcons } from "../OrderCards";
import { getPracticeId } from "../../config/practice";
import PhysicianSearch from "../referralPhysicians/PhysicianSearch";
import AddPhysicianDialog from "../referralPhysicians/AddPhysicianDialog";
import ManagePhysiciansDialog from "../referralPhysicians/ManagePhysiciansDialog";
import { CLOSED_ACCESS, fetchAccess } from "../referralPhysicians/referralPhysiciansApi";
const ReferalsNavButtons = ({
  data,
  userdata,
  referals,
  selectedCard,
  getordersData,
  fetchsuggestions,
  loading,
  selectedSuggestionList,
}) => {
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedSuggestion, setSelectedSuggestion] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [selectedDx, setSelectedDx] = useState("");
  const [fetcheddata, setFetcheddata] = useState([]);
  const [fetchingDx, setFetchingDx] = useState(false);
  const [selectedAddTabs, setSelectedAddTabs] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const practiseid = getPracticeId();
  const dispatch=useDispatch()

 const userConfig = useSelector((state) => state.userconfig);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState("");
  // Referral physicians directory (owner item 3, 2026-10-19): search every active
  // physician, Add (Order privilege), Manage (admins). The server decides; v2 only.
  const [rpAccess, setRpAccess] = useState(CLOSED_ACCESS);
  const [addOpen, setAddOpen] = useState(false);
  const [addName, setAddName] = useState("");
  const [manageOpen, setManageOpen] = useState(false);
  const RelatedResults = useSelector(
    (state) => state.universalsearcher.searchResults
  );
  const { id, dt } = useParams();
  const appointmentInfo = useSelector((state) => state.appinfo.appointmentInfo);
  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  let fav=userConfig?.config?.fav_referrals||[]
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );

  useEffect(() => {
    if (referals.length === 0) {
      setSelectedTabs([]); // Clear selectedTabs if no referrals
      return;
    }

    // Filter doctor names from `data` where doctor_name matches the ordername's prefix in referals
    const selectedIndexes = data
      .map((item) =>
        referals.some(
          (referral) =>
            referral.ordername.split("-")[0].trim() === item.doctor_name // Check if doctor_name matches the referral's ordername prefix
        )
          ? item.doctor_name // If match, include this doctor_name in the selected list
          : null
      )
      .filter((doctorName) => doctorName !== null); // Filter out any null values

    setSelectedTabs(selectedIndexes); // Set the filtered doctor names in selectedTabs
    console.log("Data select:", selectedTabs); // Debugging selectedTabs state
  }, [data, referals]); // Runs every time `data` or `referals` changes

  console.log("DataD", referals);

  console.log("Data", data);

  const handleTabClick = (item) => {
    console.log(item,'item')
    setSelectedTabs([item.doctor_name]);
    setSelectedDoctor(item.doctor_name);
    setModalContent(item);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const fetchInitialData = async () => {
    setFetchingDx(true);
    try {
      const response = await api.get(
        `/v1/${practiseid}/orders/get-referral-suggestions`
      );
      setFetcheddata(response.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setFetchingDx(false);
    }
  };
const updateFavLabs = async (lab) => {
  try {
    let updatedFavs = [...fav];
    if (!updatedFavs.includes(lab)) {
      updatedFavs.push(lab);
    }
   const response= await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_referrals: updatedFavs,
    });
 if (response.status === 200) {
      // Update Redux state with the new config
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
        fav_referrals: updatedFavs,
        },
      }));
    }
    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error updating fav labs:", error);
  }
};
const removeFavbutton = async (lab) => {
  try {
    // Create a new array without the lab to remove
    const updatedFavs = fav.filter((l) => l !== lab);

    // Update the server
    const response = await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_referrals: updatedFavs,
    });

    if (response.status === 200) {
      // Update Redux state
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
          fav_referrals: updatedFavs,
        },
      }));
    }

    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error removing fav lab:", error);
  }
};
const handlebuttonclick = async (y) => {
  if (isLoading) return; // Prevent multiple clicks
  isLoading = true;

  try {
    // A favourite outside the 15 chips shown is still a physician: open it by name.
    const contentToAdd = data?.find((x)=>x.doctor_name===y) || { doctor_name: y }
console.log(contentToAdd,'ddddddddddd')
    if (!selectedTabs.includes(contentToAdd?.doctor_name) &&
        !selectedSuggestionList.some((item) => item.doctor_name === contentToAdd?.doctor_name)) {
      await handleTabClick(contentToAdd);
      selectedTabs.push(contentToAdd?.doctor_name);
    }
  } catch (error) {
    console.error("Error in handleStrepFluCovidClick:", error);
  } finally {
    isLoading = false;
  }
};
  useEffect(() => {
    if (isModalOpen) {
      fetchInitialData();
    }
  }, [isModalOpen]);

  // (A second referrals-doctors list call whose answer was never used was here;
  // the tab, referals.jsx, loads the list.)
  useEffect(() => {
    let live = true;
    fetchAccess().then((a) => {
      if (live) setRpAccess(a);
    });
    return () => {
      live = false;
    };
  }, []);
  const fetchMedicationSuggestions = useCallback(
    debounce(async () => {
      if (inputValue.trim().length > 1) {
        try {
          const response = await api.post(
            `/v1/${practiseid}/orders/referral-suggestions/search`,
            {
              item: inputValue,
            }
          );
          if (response.status === 200) {
            setSearchResults(response.data);
          }
        } catch (error) {
          console.error("Error fetching suggestions:", error);
        }
      }
    }, 300),
    [inputValue]
  );

  useEffect(() => {
    fetchMedicationSuggestions();
    return () => fetchMedicationSuggestions.cancel();
  }, [inputValue, fetchMedicationSuggestions]);

  const submit = async () => {
    setIsSubmitting(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/orders/insert/${appointmentInfo.patientid}/referral`,
        {
          patient_name: `${appointmentInfo.firstname || ""} ${
            appointmentInfo.lastname || ""
          }`.trim(),
          tov: tovValue,
          lov: userdata.lov,
          diagnosis: "check",
          ordertype: "Referrals",
          ordername: `${selectedDoctor}-${selectedDx}`,
          schedule: "",
          provider: userdata.linked_provider,
          status: "CREATED",
          confirm_status: "E",
          orderdate: dt ? dt : new Date(),
        }
      );
      if (response.status === 200) {
        setIsModalOpen(false); // Close the modal on success
      }
      fetchsuggestions();
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTabClickInhouse = async (itemContent) => {
    const isSelected = selectedTabs.includes(itemContent);
    const orderType = ["STREP TEST", "FLU TEST", "COVID TEST"].includes(
      itemContent
    )
      ? "Diagnostic test"
      : "labs";
    try {
      if (isSelected) {
        // Call delete API
        const orderToDelete = RelatedResults.find(
          (x) => x.ordername === itemContent
        );

        if (orderToDelete) {
          const deleteResponse = await api.delete(
            `/v1/${practiseid}/orders/delete/order/${orderToDelete.ordre_id}`,
            {
              data: {
                // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
                orderdate:
                  dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                    ? dt.split(" ")[0]
                    : new Date().toISOString().split("T")[0],
              },
            }
          );
          console.log("Delete API Response:", deleteResponse.data);
        } else {
          console.error("Order ID not found for deletion");
        }
      } else {
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${userdata.patientid}/orders/create`,
          {
            department_id: 1,
            patient_name: `${userdata.firstname || ""} ${
              userdata.lastname || ""
            }`.trim(),
            tov: tovValue, // purpose
            lov: userdata.lov,
            diagnosis: "",
            ordertype: orderType, // tabs
            ordername: itemContent, // buttons
            schedule: selectedCard, // t/f-schedule
            // provider: userdata.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
            orderdate:
              dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                ? dt.split(" ")[0]
                : new Date().toISOString().split("T")[0],
            encounterid: 0,
          }
        );
      }

      // Update state after the API call
      setSelectedTabs((prevSelected) => {
        if (isSelected) {
          // Deselect if already selected
          return prevSelected.filter((content) => content !== itemContent);
        } else {
          // Select if not already selected
          return [...prevSelected, itemContent];
        }
      });
      fetchsuggestions();
    } catch (error) {
      console.error("Error in handleTabClick:", error);
    }
  };

  let isLoadingInHouseLabs = false; // This will track whether the function is already running
const inHouseLabsContent = [
      "CBC",
      "A1C",
      "CMP",
      "LIPIDS",
      "MAGNESIUM",
      "URIC ACID",
      "THYROID PANEL",
      "VIT D",
      "VIT B12",
      "TESTO",
    ];
  const handleInHouseLabsClick = async () => {
    if (isLoadingInHouseLabs) return; // Prevent double-clicking if already loading
    isLoadingInHouseLabs = true; // Set loading to true to prevent further invocations

    
    try {
      // Filter out the items that are already in selectedTabs
      const itemsToAdd = inHouseLabsContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !getordersData?.look.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs in parallel
        await Promise.all(
          itemsToAdd.map((content) => handleTabClickInhouse(content))
        );

        // Update selectedTabs with the newly added items
        selectedTabs.push(...itemsToAdd);
      }
    } catch (error) {
      console.error("Error in handleInHouseLabsClick:", error);
    } finally {
      isLoadingInHouseLabs = false; // Reset the loading state after the operation is complete
    }
  };

  let isLoading = false; // This will track whether the function is already running
 const stripfluContent = ["STREP TEST", "FLU TEST", "COVID TEST"];
  const handleStrepFluCovidClick = async () => {
    if (isLoading) return; // Prevent double-clicking if already loading
    isLoading = true; // Set loading to true to prevent further invocations

   

    try {
      // First, filter out the items that are already in selectedTabs or selectedSuggestionList
      const itemsToAdd = stripfluContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !getordersData?.look.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs or selectedSuggestionList in parallel
        await Promise.all(
          itemsToAdd.map((content) => handleTabClickInhouse(content))
        );
      }
    } catch (error) {
      console.error("Error in handleStrepFluCovidClick:", error);
    } finally {
      isLoading = false; // Reset the loading state after the operation is complete
    }
  };

  // A physician picked in search, just added, or chosen from a duplicate warning:
  // the same diagnosis step as clicking its chip (the chips show the 15 most used).
  const openReferralFor = (row) => {
    if (!row || !row.doctor_name) return;
    handleTabClick({ id: row.id, doctor_name: row.doctor_name });
  };
  const openAddPhysician = (name = "") => {
    setAddName(name);
    setAddOpen(true);
  };
  const physicianAdded = (row, opts = {}) => {
    setAddOpen(false);
    if (!row) return;
    if (opts.addFavourite) updateFavLabs(row.doctor_name);
    fetchsuggestions();
    openReferralFor(row);
  };
  const pickPhysician = (row) => {
    setAddOpen(false);
    openReferralFor(row);
  };
  const physicianAddedByAdmin = (row, opts = {}) => {
    if (row && opts.addFavourite) updateFavLabs(row.doctor_name);
    fetchsuggestions();
  };

  const labelStyle = {
    display: "block",
    marginBottom: 8,
    color: "#4a5573",
    fontSize: 13,
    fontWeight: 750,
    letterSpacing: "1px",
    textTransform: "uppercase",
  };

  return (
    <div className="bmor">
      <div className="bmor-section">
        <span className="bmor-section-title">
          <span style={{ width: 14, height: 14, color: "#e0a422", display: "inline-flex" }}>{OrderIcons.star}</span>
          Favourites
        </span>
        <span className="bmor-section-hint">Your saved referrals</span>
      </div>
      <div className="bmor-chips">
        {fav.map((lab) => {
          const isSelected = Array.isArray(selectedTabs) && selectedTabs.includes(lab);
          return (
            <button
              key={lab}
              type="button"
              className={`bmor-chip${isSelected ? " on" : ""}`}
              onClick={() => handlebuttonclick(lab)}
            >
              {isSelected ? OrderIcons.check : OrderIcons.plus}
              {lab}
              <span
                className="bmor-chip-x"
                role="button"
                title="Remove from favourites"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent parent click
                  removeFavbutton(lab);
                }}
              >
                ×
              </span>
            </button>
          );
        })}
        <button
          type="button"
          className="bmor-chip ghost"
          aria-expanded={!!selectedAddTabs}
          onClick={() => setSelectedAddTabs((prev) => !prev)}
        >
          {selectedAddTabs ? "Done" : <>{OrderIcons.plus}Add favourite</>}
        </button>
      </div>
      {!!selectedAddTabs && (
        <div className="bmor-chips" style={{ marginTop: 10 }}>
          {data
            .filter(
              (x) =>
                x.content !== "INHOUSE LABS-MALE" &&
                x.content !== "INHOUSE LABS-FEMALE" &&
                !fav.includes(x.doctor_name)
            )
            .map((item) => (
              <button
                key={item.doctor_name}
                type="button"
                className="bmor-chip"
                onClick={() => updateFavLabs(item.doctor_name)}
              >
                <span style={{ color: "#d0533f", display: "inline-flex" }}>{OrderIcons.heart}</span>
                {item.doctor_name}
              </button>
            ))}
        </div>
      )}

      <div className="bmor-section">
        <span className="bmor-section-title">
          <span className="bmor-section-dot" style={{ background: "#2f6fb2" }} />
          Referrals
        </span>
        <span className="bmor-section-hint">Select to add, select again to remove</span>
      </div>
      {loading ? (
        <div className="bmor-skel">
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" width={120} height={42} style={{ borderRadius: 999 }} />
          ))}
        </div>
      ) : data.length > 0 ? (
        <div className="bmor-chips">
          {data.map((item) => {
            const isSelected = selectedTabs.includes(item.doctor_name);
            return (
              <button
                key={`${item.id}-${item.order_id}`}
                type="button"
                className={`bmor-chip${isSelected ? " on" : ""}`}
                aria-pressed={isSelected}
                onClick={() => handleTabClick(item)}
              >
                {isSelected ? OrderIcons.check : OrderIcons.plus}
                {item.doctor_name}
              </button>
            );
          })}
        </div>
      ) : (
        <p className="bmor-empty-line">No suggestions found</p>
      )}
      {rpAccess.enabled && (
        <>
          <PhysicianSearch canAdd={!!rpAccess.can_add} onPick={openReferralFor} onAddNew={openAddPhysician} />
          {(rpAccess.can_add || rpAccess.can_manage) && (
            <div className="bmor-chips" style={{ marginTop: 10 }}>
              {rpAccess.can_add && (
                <button type="button" className="bmor-chip ghost" onClick={() => openAddPhysician("")}>
                  {OrderIcons.plus}Add physician
                </button>
              )}
              {rpAccess.can_manage && (
                <button type="button" className="bmor-chip ghost" onClick={() => setManageOpen(true)}>
                  Manage physicians
                </button>
              )}
            </div>
          )}
        </>
      )}

      <Dialog open={isModalOpen} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ style: { borderRadius: 16 } }}>
        <DialogContent>
          <div className="bmor">
            <div className="flex justify-between items-center">
              <h2 style={{ margin: 0, color: "#1d2951", fontSize: 18, fontWeight: 700 }}>{modalContent.doctor_name || modalContent.content}</h2>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
            <label style={{ ...labelStyle, marginTop: 8 }}>Diagnosis</label>
            <div className="relative w-full">
              <FontAwesomeIcon
                icon={faSearch}
                className="absolute top-1/2 transform -translate-y-1/2 text-gray-400"
                style={{ left: 14 }}
              />
              <input
                type="text"
                className="w-full outline-none"
                style={{
                  height: 46,
                  paddingLeft: 40,
                  paddingRight: 14,
                  border: "1px solid #e1e6ee",
                  borderRadius: 11,
                  background: "#fff",
                  fontFamily: "Inter, sans-serif",
                  fontSize: 15,
                  color: "#151e36",
                }}
                placeholder="Search here"
                value={inputValue}
                onChange={(e) => {
                  setInputValue(e.target.value);
                  setIsChecked(false);
                }}
              />
            </div>
            {searchResults && !isChecked && searchResults.length > 0 && (
              <ul
                className="w-full"
                style={{ marginTop: 8, padding: 0, listStyle: "none", border: "1px solid #e1e6ee", borderRadius: 11, overflow: "hidden" }}
              >
                {searchResults.map((suggestion, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      setInputValue(suggestion.condition_name);
                      setSelectedDx(suggestion.condition_name);
                      setIsChecked(true);
                    }}
                    className="hover:bg-[#f2f5fa] cursor-pointer"
                    style={{ padding: "10px 14px", fontSize: 14, color: "#151e36" }}
                  >
                    {suggestion.condition_name}
                  </li>
                ))}
              </ul>
            )}
            {fetcheddata.length > 0 && (
              <>
                <div className="bmor-section">
                  <span className="bmor-section-title">Suggested diagnoses</span>
                </div>
                {fetchingDx ? (
                  <div className="bmor-skel">
                    {Array.from({ length: 3 }).map((_, index) => (
                      <Skeleton key={index} variant="rectangular" width={120} height={42} style={{ borderRadius: 999 }} />
                    ))}
                  </div>
                ) : (
                  <div className="bmor-chips">
                    {fetcheddata.map((item, index) => {
                      const isSelected = selectedDx === item.suggtion_name;
                      return (
                        <button
                          key={index}
                          type="button"
                          className={`bmor-chip${isSelected ? " on" : ""}`}
                          aria-pressed={isSelected}
                          onClick={() => {
                            setInputValue("");
                            setSelectedDx(item.suggtion_name);
                          }}
                        >
                          {isSelected ? OrderIcons.check : OrderIcons.plus}
                          {item.suggtion_name}
                        </button>
                      );
                    })}
                  </div>
                )}
              </>
            )}
            <div className="w-full flex justify-end" style={{ marginTop: 20 }}>
              <button
                type="button"
                onClick={() => submit()}
                disabled={isSubmitting}
                style={{
                  height: 46,
                  padding: "0 26px",
                  border: 0,
                  borderRadius: 11,
                  background: "#1d2951",
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 650,
                  opacity: isSubmitting ? 0.6 : 1,
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                }}
              >
                {isSubmitting ? "Submitting..." : "Continue"}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      {rpAccess.can_add && (
        <AddPhysicianDialog open={addOpen} mode="add" initialName={addName} access={rpAccess}
                            onClose={() => setAddOpen(false)} onSaved={physicianAdded} onUseExisting={pickPhysician} />
      )}
      {rpAccess.can_manage && (
        <ManagePhysiciansDialog open={manageOpen} access={rpAccess} onClose={() => setManageOpen(false)}
                                onChanged={fetchsuggestions} onAdded={physicianAddedByAdmin} />
      )}
    </div>
  );
};

// Debounce utility function
function debounce(func, wait) {
  let timeout;
  const debounced = (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
  debounced.cancel = () => clearTimeout(timeout);
  return debounced;
}
export default ReferalsNavButtons;
